import ScrollMagic from '../../vendors/ScrollMagic.min';

export const paralax = {
    init: function() {

        const parallaxEl = document.querySelectorAll('[data-parallax]');
        if (!parallaxEl ) return;

        // if (window.innerWidth >= 1200) {
            var ctrl = new ScrollMagic.Controller({
                globalSceneOptions: {
                    triggerHook: 0.85
                    // duration: 100
                }
            });

            var smagic = [];
        
            for (let i = 0; i < parallaxEl.length; i++) {

                
                smagic[i] = new ScrollMagic.Scene({
                    triggerElement: parallaxEl[i]
                })
                .setClassToggle(parallaxEl[i], "parallax-active")
                .addTo(ctrl);
            }
        // }

    },
    refresh: function() {

    }
}
